import { Dialog, DialogContent, DialogActions, Box } from "@mui/material";
import { useState, useEffect } from "react";
import { updateClient } from "../../components/functions/Projects";
import CustomButton from "../../ui/button/Button";

const EditClientModal = ({ API_URL, open, onClose, onConfirm, cliente }) => {
  const [clienteForm, setClienteForm] = useState(null);

  useEffect(() => {
    if (open) {
      setClienteForm(cliente);
    }
  }, [open]);

  const handleConfirm = async () => {
    if (!clienteForm) return;

    if (!clienteForm.razonSocial || clienteForm.razonSocial.trim() === "") {
      return;
    }

    try {
      await updateClient(API_URL, clienteForm);
      onConfirm(true, clienteForm);
    } catch (error) {
      onConfirm(false, cliente);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        <div>
          <h2>Editar Cliente</h2>
          <Box
            className="stepper-step-content"
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: "100%",
            }}
          >
            <div
              className="d-grid align-items-center"
              style={{ gridTemplateColumns: "250px 1fr", rowGap: "16px" }}
            >
              <label className="form-label">Nombre:</label>
              <input
                className="form-input"
                type="text"
                placeholder="Ingresa el nombre..."
                value={clienteForm?.razonSocial || ""}
                onChange={(e) =>
                  setClienteForm((prev) => ({
                    ...prev,
                    razonSocial: e.target.value,
                  }))
                }
              />
              <label className="form-label">Nombre corto:</label>
              <input
                className="form-input"
                type="text"
                placeholder="Ingresa el nombre corto..."
                value={clienteForm?.alias || ""}
                onChange={(e) =>
                  setClienteForm((prev) => ({
                    ...prev,
                    alias: e.target.value,
                  }))
                }
              />
            </div>
          </Box>
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={onClose}
        />
        <CustomButton
          className="notifications-button"
          text={"Guardar"}
          color={"#FFFFFF"}
          background={"#223D51"}
          fontStyle={"normal"}
          fontWeight={500}
          fontSize={"14px"}
          height={"40px"}
          type={"button"}
          onClick={handleConfirm}
        />
      </DialogActions>
    </Dialog>
  );
};

export default EditClientModal;
